import {
    WholesaleAccountWarehouseAgreement
} from "../../../../../../../models/accounts/customer-account/wholesale-account/wholesale.account";
import {AgreementData} from "./model";

export const toData = (items: WholesaleAccountWarehouseAgreement[]): AgreementData[] => {
    return items.map(item => ({
        number: item.number,
        date: item.date,
        warehouse: item.access.warehouse.id,
        maxAmount: item.access.maxAmount,
        readonly: item.access.readonly,
        sort: item.access.sort,
        transactionType: item.access.transactionType
    }))
}